module.exports = __webpack_public_path__ + "static/img/0A.7c493446.svg";